import { cld, cldSrcSet } from "../services/cloudinaryService";

// Miniatura ligera: el navegador elige 400/800/1200px según pantalla, nunca el original
export default function Foto({ url, alt, sizes = "(max-width: 820px) 50vw, 33vw", eager = false }) {
    return (
        <img
            src={cld(url, 800)}
            srcSet={cldSrcSet(url)}
            sizes={sizes}
            alt={alt}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            onLoad={(e) => e.currentTarget.classList.add("in")}
        />
    );
}
